module.exports = __webpack_public_path__ + "img/Pulverização turbina.bbeae22f.webp";